import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateProjectArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateProject(
    $id: Int!
    $name: String
    $projectFolderId: ID
    $updateProjectFolder: Boolean
  ) {
    updateProject(
      id: $id
      name: $name
      projectFolderId: $projectFolderId
      updateProjectFolder: $updateProjectFolder
    ) {
      id
      name
      projectFolder {
        id
      }
    }
  }
`;

type Variables = Pick<
  BackendMutationUpdateProjectArgs,
  'id' | 'name' | 'projectFolderId' | 'updateProjectFolder'
>;
type Result = Pick<BackendProject, 'id' | 'name' | 'projectFolder'>;

export const updateProject = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
